import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInformationService } from '../app-information.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class QuickbooksService {
    static serviceName: string;

    constructor(private http: HttpClient, private appInfo: AppInformationService) {
        QuickbooksService.serviceName = environment.serviceName;
    }

    async isAuthorized() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/isAuthorized`, {}).toPromise();
        return result as boolean;
    }

    async authorize() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/authorize`, {}).toPromise();
        return result as string;
    }

    async disconnect() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/disconnect`, {}).toPromise();
        return result as string;
    }


    async authorizeCallback(code, realmId, state) {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/authorizeCallback`, { code, realmId, state }).toPromise();
        return result as string;
    }

    async dealerExport() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/dealerExport`, {}).toPromise();
        return result as string;
    }

    async dealerSyncIds() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/dealerSyncIds`, {}).toPromise();
        return result as string;
    }

    async vendorExport() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/vendorExport`, {}).toPromise();
        return result as string;
    }

    async vendorSyncIds() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/vendorSyncIds`, {}).toPromise();
        return result as string;
    }

    async purchaseOrderExport() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/purchaseOrderExport`, {}).toPromise();
        return result as string;
    }



    async invoiceExport() {
        const result = await this.http.post(`${QuickbooksService.serviceName}/quickbooks/invoiceExport`, {}).toPromise();
        return result as string;
    }
}
